export { default } from './MarcHoldingsTable';



// WEBPACK FOOTER //
// ./app/components/shared/MarcHoldingsTable/index.js